import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationGroupMasterReferenceData = createAsyncThunk(
  'stop/getVerificationGroupMasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationGroupMasterReferenceSlice = createSlice({
  name: 'stop/verificationGroupMasterReference',
  initialState: null,
  reducers: {
    resetVerificationGroupMasterReference: () => null,
  },
  extraReducers: {
    [getVerificationGroupMasterReferenceData.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetVerificationGroupMasterReference } =
  verificationGroupMasterReferenceSlice.actions;

export default verificationGroupMasterReferenceSlice.reducer;
